import React, { useState, useEffect } from 'react';
import { updateData } from '../../api/api';
import { MEMBERSHIP, USE_STREAK_SAVER } from '../../helpers/Constant';
import { useNavigate } from 'react-router-dom';

function StreakSaver({ user, onUserRefresh, showStreakInfoModal, closeStreakInfoModal, streakModalSignals }) {
    const [userData, setUserData] = useState(user);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showStreakLostModal, setShowStreakLostModal] = useState(false);

    const handleUseStreakSaver = async () => {
        const response = await updateData(USE_STREAK_SAVER, { useStreak: true });
        if (response.status === 200) {
            await onUserRefresh();
        }
        setShowModal(false);
        streakModalSignals(false);
    }

    const handleCloseModal = async () => {
        const response = await updateData(USE_STREAK_SAVER, { useStreak: false });
        if (response.status === 200) {
            await onUserRefresh();
        }
        setShowModal(false);
        setShowStreakLostModal(false);
        streakModalSignals(false);
    }

    useEffect(() => {
        setUserData(user);
    }, [user]);

    useEffect(() => {
        if (userData && userData.userStreaks?.currentStreak < userData.userStreaks?.lastStreak && userData.userStreaks?.streakSavers > 0) {
            setShowModal(true);
            streakModalSignals(true);
        }else if(userData && userData.userStreaks?.streakReset) {
            setShowStreakLostModal(true);
            streakModalSignals(true);
        }else{
            streakModalSignals(false);
        }
    }, [userData]);

    return (
        <>
            <div className={`streak_saver_save_modal modal ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }}>
                <div className='modal-dialog modal-dialog-centered' role='document'>
                    <div className='modal-content modal_content streak_saver_modal'>
                        <div className='modal-body p-0 text-center'>
                            <img className='streak_saver_image' src='../images/streak-saver.png' alt='Streak Saver' width={175} />
                            <h2 className='streak_saver_title fw-bold text-uppercase px-2'>Save Streak?</h2>
                            <div className='streak_saver_status fw-light text-capitalize px-2'>You Have Been Saved</div>
                            <div className='streak_saver_description fw-medium text-white py-3 px-2'>
                                <ul className='list-unstyled my-1'>
                                    <li>You missed a day, but your Streak Saver can protect your progress.</li>
                                </ul>
                            </div>
                            <div className='streak_saver_feedback fw-light px-2'>Out of savers? Upgrade to <br />Premium to get more protection.</div>
                            <div className='streak_saver_buttons d-flex flex-column align-items-center py-3 px-2'>
                                <button className='cta_button bg-warning border-0' onClick={handleUseStreakSaver}>Use It</button>
                                <button className='cta_button bg-warning border-0' onClick={handleCloseModal}>Reset Streak</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`streak_saver_lost_modal modal ${showStreakLostModal ? 'show' : ''}`} style={{ display: showStreakLostModal ? 'block' : 'none' }}>
                <div className='modal-dialog modal-dialog-centered' role='document'>
                    <div className='modal-content modal_content streak_saver_modal'>
                        <div className='modal-body p-0 text-center'>
                            <img className='streak_saver_image' src='../images/streak-saver.png' alt='Streak Saver' width={175} />
                            <h2 className='streak_saver_title fw-bold text-uppercase px-2'>Streak Lost</h2>
                            <div className='streak_saver_status fw-light text-capitalize px-2'>Not Enough Streak Savers.</div>
                            <div className='streak_saver_description fw-medium text-white py-3 px-2'>
                                <p>You missed multiple days and didn’t have enough Streak Savers to protect your streak.</p>
                                <p className='opacity-50'>
                                    Your streak has reset — but you can start again today and make a stronger comeback<br />
                                    - Build a new streak from today -<br />
                                    -  Use Streak Savers to avoid this next time -
                                </p>
                            </div>
                            <div className='streak_saver_feedback fw-light px-2'>Premium users get more <br />Streak Savers to stay consistent.</div>
                            <div className='streak_saver_buttons d-flex flex-column align-items-center py-3 px-2'>
                                <button className='cta_button bg-warning border-0 text-uppercase' onClick={() => navigate(`/${MEMBERSHIP}`)}>Buy Premium</button>
                                <button className='cta_button bg-warning border-0 text-uppercase' onClick={handleCloseModal}>Start New Streak</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`streak_saver_info_modal modal ${showStreakInfoModal ? 'show' : ''}`} style={{ display: showStreakInfoModal ? 'block' : 'none' }}>
                <div className='modal-dialog modal-dialog-centered' role='document'>
                    <div className='modal-content modal_content streak_saver_modal'>
                        <div className='modal-body p-0 text-center'>
                            <img className='streak_saver_image' src='../images/streak-saver.png' alt='Streak Saver' width={175} />
                            <h2 className='streak_saver_title fw-bold text-uppercase px-2'> Don’t Break Your Streak!</h2>
                            <div className='streak_saver_status fw-light text-capitalize px-2'>Missed a day? No worries.</div>
                            <div className='streak_saver_description fw-medium text-white py-3 px-2'>
                                <ul className='list-unstyled my-1'>
                                    <li>Streak Saver protects your streak even if you skip a day.</li>
                                    <li>Saves your streak for 1 missed day</li>
                                    <li>Use it automatically when you miss a day.</li>
                                    <li>Keep your progress going strong</li>
                                </ul>
                            </div>
                            <div className='streak_saver_feedback fw-light px-2'>You have {userData?.userStreaks?.streakSavers || 0} Streak Saver(s) available.</div>
                            <div className='streak_saver_buttons d-flex flex-column align-items-center py-3 px-2'>
                                <button className='cta_button bg-warning border-0 text-uppercase' onClick={() => closeStreakInfoModal()}>Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {(showModal || showStreakLostModal || showStreakInfoModal) && <div className="modal-backdrop show"></div>}
        </>
    );
}

export default StreakSaver;